import React, {Component} from "react";
import {Col} from "reactstrap";
import QRCode from "qrcode.react";
import {Strings} from "./Strings";

export class LinkQR extends Component {
    render() {
        return <Col md={this.props.md} className="botSpace">
            <div className="block">
                <p className="small qrCode">{Strings.qrDescription}</p>
                <QRCode className="qrCode" value={window.location.href} size={window.location.href.length}/>
            </div>
        </Col>;
    }
}